import React from "react";
import { skills } from "./data";

function SkillModules() {
  return (
    <section className="ops-section" id="skills">
      <div className="section-heading">
        <p>System Capabilities</p>
        <h2>Skills loaded as operational modules</h2>
      </div>
      <div className="skills-grid">
        {skills.map((skill) => (
          <article className="skill-module glass-panel" key={skill.title}>
            <div className="module-header">
              <span>{skill.signal}</span>
              <h3>{skill.title}</h3>
            </div>
            <p>{skill.description}</p>
            <ul>
              {skill.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}

export default SkillModules;
